import {PropTypes} from 'react';
import Component from 'react-pure-render/component';

export default class FormInput extends Component {
  static propTypes = {
    onBlur: PropTypes.func,
    onFocus: PropTypes.func
  }

  onInputBlur(event) {
    const {onBlur} = this.props;

    if ('function' === typeof onBlur) {
      onBlur(event);
    }
  }

  onInputFocus(event) {
    const {onFocus} = this.props;

    if ('function' === typeof onFocus) {
      onFocus(event);
    }
  }
}
